import Model from 'flarum/common/Model';
export default class Modal extends Model {
  dismissibleCloseBtn() {
    return Model.attribute('dismissibleCloseBtn').call(this);
  }
  dismissibleEscKey() {
    return Model.attribute('dismissibleEscKey').call(this);
  }
  dismissibleBackdropClick() {
    return Model.attribute('dismissibleBackdropClick').call(this);
  }
  size() {
    return Model.attribute('size').call(this);
  }
  title() {
    return Model.attribute('title').call(this);
  }
  content() {
    return Model.attribute('content').call(this);
  }
  isEnabled() {
    return Model.attribute('isEnabled').call(this);
  }
  activeFrom() {
    return Model.attribute('activeFrom', Model.transformDate).call(this);
  }
  activeUntil() {
    return Model.attribute('activeUntil', Model.transformDate).call(this);
  }
  ctaLabel() {
    return Model.attribute('ctaLabel').call(this);
  }
  ctaHref() {
    return Model.attribute('ctaHref').call(this);
  }
  ctaTarget() {
    return Model.attribute('ctaTarget').call(this);
  }
  shouldShow() {
    return Model.attribute('shouldShow').call(this);
  }
}
flarum.reg.add('glowingblue-modals', 'common/models/Modal', Modal);